import { SpinnerIconSVG } from 'src/assets/svg';

type Props = {
    color?: string;
};

export const Spinner = ({ color = 'woodyBrown' }: Props) => {
    return <SpinnerIconSVG className={`animate-spin h-8 w-8 ${color}`} />;
};
